import { Action } from '@ngrx/store';
import { CasaSettings } from '../../types/casa-settings.types';

export enum CasaSettingsActionTypes {
  Load = '[CASA Settings] Load',
  LoadSuccess = '[CASA Settings] Load Success',
  LoadFail = '[CASA Settings] Load Fail'
}

export class LoadCasaSettings implements Action {
  public readonly type = CasaSettingsActionTypes.Load;
}

export class LoadCasaSettingsSuccess implements Action {
  public readonly type = CasaSettingsActionTypes.LoadSuccess;

  constructor(public payload: CasaSettings) {}
}

export class LoadCasaSettingsFail implements Action {
  public readonly type = CasaSettingsActionTypes.LoadFail;

  constructor(public payload: string) {}
}
export type CasaSettingsActionsUnion =
  | LoadCasaSettings
  | LoadCasaSettingsSuccess
  | LoadCasaSettingsFail;
